<template>
    <section class="col-12">
        <slot v-if="timesheet">
            <span>Material Used <a href="#" data-toggle="modal"
                                      data-target="#modalInventories"
                                      data-backdrop="static"
                                      data-keyboard="false" class="fa fa-plus text-success"></a></span>
            <span style="padding-left: 40px;  padding-top: 10px; display: inline-block">&nbsp;</span>
            <label><input :checked="materialInvoice === 'inspection'" type="radio" name="material_invoice" value="inspection"> Invoice with Inspection</label>
            &nbsp;
            <label><input :checked="materialInvoice === 'separately'" type="radio" name="material_invoice" value="separately"> Invoice Separately</label>
            <label><input :checked="materialInvoice === ''" style="opacity: 0" type="radio" name="material_invoice" value=""><span
                style="color: red">X</span></label>
        </slot>
        <label v-else><strong>Parts & Materials</strong></label>
        <div class="table-responsive">
        <vue-good-table v-if="!timesheet"
            id="table-material-schedules"
            ref="table-material-schedules"
            :select-options="{ enabled: !readonly, selectOnCheckboxOnly: true, }"
            :search-options="{ enabled: false,  placeholder:'Filter'}"
            @on-selected-rows-change="selectionChanged"
            :columns="columns"
            :rows="rows">
            <div slot="table-actions" v-if="!readonly">
                <div class="btn-group">
                    <button v-if="actionsLocal.add" type="button" title="Add" data-toggle="modal"
                            data-target="#modalInventories"
                            data-backdrop="static"
                            data-keyboard="false" class="btn btn-info action-label" style="font-size: 12px;"><i
                        class="fa fa-plus"></i> Add
                    </button>
                    <button v-if="actionsLocal.remove" type="button" @click="removeInventory" class="btn  btn-danger action-label"
                            title="Remove"
                            style="font-size: 12px;"><i class="fa fa-minus"></i> Remove
                    </button>
                    <button v-if="actionsLocal.reset" type="button" @click="removeColumnsStore"
                            class="btn  btn-warning action-label" title="Reset"
                            style="font-size: 12px;"><i class="fa fa-undo"></i> Reset
                    </button>
                    <button v-if="actionsLocal.file" type="button" @click="exportExcel" class="btn  btn-success action-label"
                            title="Export Excel"
                            style="font-size: 12px;"><i class="fas fa-file-excel"></i> Excel
                    </button>
                    <button v-if="actionsLocal.columns" type="button" data-toggle="modal"
                            data-target="#columnsModalMaterial" data-backdrop="static"
                            title="Columns"
                            data-keyboard="false" class="btn btn-secondary action-label" style="font-size: 12px;"><i
                        class="fa fa-list"></i> Custom
                    </button>
                </div>
            </div>
            <template slot="table-row" slot-scope="props">
                   <span v-if="props.column.field === 'custom_field'">
                       <span v-if="customField === 'Quantity'" class="d-flex">
                               <input type="hidden" :name="'schedule_materials['+props.row.id+'][inventory_id]'"
                                      :value="props.row.id">
                           <input :readonly="readonly" class="form-control"
                                  :name="'schedule_materials['+props.row.id+'][quantity]'"
                                  :value="props.row['quantity'] || 1">
                            </span>
                   </span>
                <span v-else-if="props.column.field === 'actions'">
                       <slot name="actions" :props="props" :columns="columns"></slot>
                   </span>
                <span v-else> {{ props.formattedRow[props.column.field] }}</span>
            </template>
        </vue-good-table>
        <table class="table" v-if="timesheet">
            <tr>
                <th><span style="margin-top: 4px;" class="text-success">D</span></th>
                <th><span style="margin-top: 4px;" class="text-success">D$</span></th>
                <th></th>
                <th>Quantity</th>
                <th>Category</th>
                <th>Description</th>
                <th>Make</th>
                <th>Model</th>
                <th style="min-width: 150px;">Site Acc#</th>
                <th>Svc Tix#</th>
                <th>PO Number</th>
                <th></th>
            </tr>
            <tr v-for="(row, indexRow) in rows">
                <td>
                    <input
                        @change="syncCheckboxesD(indexRow)"
                        type="checkbox"
                        value="1"
                        v-model="row.partial_d"
                        :name="'schedule_materials[' + row.id + '][partial_d]'"
                    >
                </td>
                <td>
                    <input
                        type="checkbox"
                        value="1"
                        v-model="row.partial_d4"
                        @change.prevent.stop="syncCheckboxesD4(indexRow)"
                        :name="'schedule_materials[' + row.id + '][partial_d4]'"
                    >
                </td>
                <td>
                    <span class="text-danger" @click="removeRow(row)" style="cursor: pointer">X</span>
                </td>
                <td>
                    <input type="hidden" :name="'schedule_materials['+row.id+'][inventory_id]'"
                           :value="row.id">
                    <input :readonly="readonly" class="form-control"
                           :name="'schedule_materials['+row.id+'][quantity]'"
                            v-model="row.quantity">
                </td>
                <td>{{row.model_category_id}}</td>
                <td>{{row.description}}</td>
                <td>{{row.manufacture_id}}</td>
                <td>{{row.model_number_id}}</td>
                <td>
                    <select class="form-control" :name="'schedule_materials['+row.id+'][site_id]'">
                        <option value="">...</option>
                        <option :selected="row['site_id'] === site.id" v-for="site in sites" :value="site.id">{{site.site_acc_number}}</option>
                    </select>
                </td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </table>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="modalInventories" tabindex="-1" role="dialog"
             aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Add Material</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="height: 78vh; overflow-y: scroll;">
                        <generic-select @apply="addInventories" @selecteds="setSelecteds" @dataSave="getDataSave" :save="true"
                                        model="App\Models\Inventory"></generic-select>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="addInventories">Add Checked</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="columnsModalMaterial" tabindex="-1" role="dialog"
             aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Columns - Show/Hide</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="max-height: 400px; overflow-y: scroll;">
                        <div class="row">
                            <div v-for="(column, index) in columns" :key="index" class="col-md-4"
                                 style="border-bottom: 1px solid #DDDDDD">
                                <a href="#" @click.prevent="setStatusColumn(column)" class="small"
                                   tabIndex="-1">
                                    <span v-if="column.hidden" class="fa fa-eye-slash"></span>
                                    <span v-else class="fa fa-eye text-info"></span>
                                    &nbsp;{{ column.label }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';
import _ from "lodash";
import MaterialComponent from "../../../models/MaterialComponent";
import exportFromJSON from "export-from-json";

export default {
    name: "ScheduleMaterials",
    props: {
        inventories: {
            type: Array,
            default() {
                return []
            }
        },
        name: {
            type: String,
            default: 'materials',
            required: false
        },
        actions: {
            type: Object,
            default: null,
            required: false
        },
        customField: {
            type: String,
            default: null,
            required: false
        },
        customFieldPosition: {
            type: String,
            default: 'start',
        },
        readonly: {
            type: Boolean,
            default: false
        },
        timesheet: {
            type: Number,
            default: null
        },
        materialInvoice: {
            type: String,
            default: ''
        },
        sites: {
            type: Array,
            default: () => []
        },
    },
    data: function () {
        return {
            actionsLocal: {
                add: true,
                edit: true,
                reset: true,
                remove: true,
                columns: true,
                file: true,
            },
            items: [],
            columns: [],
            rows: [],
            order: 0,
            selecteds: [],
            materials_selecteds: [],
            ids: [],
        }
    },
    async mounted() {
         this.onMountLocal()
    },
    methods: {
        async onMountLocal() {
            if (this.actions !== null) {
                this.actionsLocal = Object.assign(this.actionsLocal, this.actions);

            }
            if (this.inventories.length > 0) {
                this.ids = this.inventories.map((e) => e.id);
                await this.getInventories()
                if (this.customField !== null) {
                    let app = this;
                    if (app.customField === 'Quantity') {
                        this.rows = this.rows.map((m) => {
                            const inventory = app.inventories.find(iv => iv.id === m.id);
                            if (inventory) {
                                m.quantity = inventory.quantity;
                                m.site_id = inventory.site_id;
                                m.partial_d = inventory.partial_d;
                                m.partial_d4 = inventory.partial_d4;
                            }
                            return m;
                        });
                    }
                }
            } else {
                await this.getInventories()
            }
        },
        syncCheckboxesD4(index) {
            const row = this.rows[index];

            if (row.partial_d4) {
                this.rows[index].partial_d = true;
            }

            this.$forceUpdate()
        },
        syncCheckboxesD(index) {
            const row = this.rows[index];

            if (!row.partial_d) {
                this.rows[index].partial_d4 = false;
            }

            this.$forceUpdate()
        },
        removeRow(row){
            this.selecteds.push(row);
            this.removeInventory()
        },
        addInventoryId(id) {
            this.site_id = id
        },
        removeInventory() {
            let app = this;
            this.rows = this.rows.filter(function (item) {
                let deleted = false;
                for (let i = 0; i < app.selecteds.length; i++) {
                    if (app.selecteds[i].id === item.id) {
                        deleted = true;
                        break;
                    }
                }
                return !deleted
            })
        },
        setSelecteds(materials) {
            this.materials_selecteds = materials;
        },
        setStatusColumn(column) {
            column.hidden = !column.hidden;
            this.setColumnsStore()
        },
        setColumnsStore() {
            localStorage.removeItem('part_materials_columns');
            let columns = this.columns.filter((col) => {
                return !col.hidden
            });
            localStorage.setItem('part_materials_columns', JSON.stringify(columns));
        },
        getColumnsStore() {
            let columns = localStorage.getItem('part_materials_columns');
            if (columns) {
                columns = JSON.parse(columns)
                this.columns = this.columns.map((col) => {
                    col.hidden = true;
                    for (let i = 0; i < columns.length; i++) {
                        if (columns[i].field === col.field) {
                            col.hidden = false;
                            break;
                        }
                    }
                    return col
                });

            }

            if (this.customField != null) {
                if (this.customFieldPosition === 'start')
                    this.columns.unshift({label: this.customField, field: 'custom_field',});
                else {
                    let lenghtColumn = this.columns.length - 1;
                    if (this.columns[lenghtColumn].field === 'actions') {
                        let lastColumn = this.columns[lenghtColumn];
                        this.columns[lenghtColumn] = {label: this.customField, field: 'custom_field'}
                        this.columns.push(lastColumn);
                    } else {
                        this.columns.push({label: this.customField, field: 'custom_field',});
                    }
                }
            }
        },
        removeColumnsStore() {
            localStorage.removeItem('part_materials_columns');
            this.getSites()
        },
        async getInventories() {
            let app = this;
            let ids = this.ids.map(function (el, index) {
                return `ids[${index}]=${el}`
            }).join('&');
            await axios.get(`/inventories/list-of-ids?${ids}`).then((response) => {
                app.columns = response.data.columns
                app.rows = response.data.rows
                app.getColumnsStore()

            })
                .catch((err) => {
                    showMessage('e', 'Error loading materials');
                    console.error(err);
                })

            this.$root.addTypeButton();

        },
        getDataSave(obj){
            this.ids.push(obj.id)
            this.getInventories()
            $('#modalInventories').modal('toggle');
        },
        async addInventories() {
            this.ids = this.rows.map(function (el) {
                return el.id;
            })


            if (this.materials_selecteds.length) {
                for (let i = 0; i < this.materials_selecteds.length; i++) {
                    this.ids.push(this.materials_selecteds[i]);
                }
            }
            this.materials_selecteds = []
            await this.getInventories()
            if (this.customField !== null) {
                let app = this;
                if (app.customField === 'Quantity') {
                    this.rows = this.rows.map((m) => {
                        const inventory = app.inventories.find(iv => iv.id === m.id);
                        if (inventory) {
                            const {
                                quantity = 1,
                                site_id = null,
                                partial_d = 0,
                                partial_d4 = 0
                            } = inventory;
                            m.quantity = quantity;
                            m.site_id = site_id;
                            m.partial_d = partial_d;
                            m.partial_d4 = partial_d4;
                        } else {
                            m.quantity = 1;
                            m.site_id = null;
                            m.partial_d = 0;
                            m.partial_d4 = 0;
                        }
                        return m;
                    });
                }
            }
            $('#modalInventories').modal('toggle');
        },
        selectionChanged(params) {
            // params.selectedRows - all rows that are selected (this page)
            this.selecteds = params.selectedRows
        },
        exportExcel() {

            let data = [];
            let header = [];
            header = this.columns.filter((col) => {
                return !col.hidden;
            })

            data.push(header.map((h) => {
                return h.label
            }))

            let fields = header.map((_) => {
                return _.field;
            })

            this.rows.forEach((row) => {
                let r = [];
                for (let i = 0; i < fields.length; i++) {
                    r.push(row[fields[i]])
                }
                data.push(r)
            })

            const fileName = 'materials'
            const exportType = exportFromJSON.types.xls

            exportFromJSON({data, fileName, exportType})
        },
        years: years
    }
}
</script>

<style scoped>
@media (max-width: 768px) {
    .modal-body {
        max-height: 70vh;
        overflow-y: auto;
        padding: 15px;
    }
}
</style>
